import React, { useReducer } from "react";
import NavContext from "./navContext";
import NavReducer from "./navReducer";
import {
  GET_NAVBAR,
  REMOVE_NAVBAR,
  GET_CONTENT,
  REMOVE_CONTENT
} from "../types";

const NavState = props => {
  const initialState = true;
  const { visibleNav, visibleContent } = true;

  const [state, dispatch] = useReducer(NavReducer, initialState);

  const getNavbar = () => {
    dispatch({
      type: GET_NAVBAR
    });
  };
  const removeNavbar = () => {
    dispatch({
      type: REMOVE_NAVBAR
    });
  };
  const getContent = () => {
    dispatch({
      type: GET_CONTENT
    });
  };
  const removeContent = () => {
    dispatch({
      type: REMOVE_CONTENT
    });
  };

  return (
    <NavContext.Provider
      value={{
        visibleNav: state.visible,
        visibleContent: state.visiblecon,
        getNavbar,
        removeNavbar,
        getContent,
        removeContent
      }}
    >
      {props.children}
    </NavContext.Provider>
  );
};
export default NavState;
